import { IconProps } from 'types/icon.type'

// TODO: Replace icon with the open source one

export const XCircleIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>X in circle icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12C2.25 6.61487 6.61487 2.25 12 2.25C17.3851 2.25 21.75 6.61487 21.75 12C21.75 17.3841 17.3852 21.75 12 21.75C6.61481 21.75 2.25 17.3841 2.25 12ZM12 3.75C7.44329 3.75 3.75 7.44329 3.75 12C3.75 16.5557 7.44335 20.25 12 20.25C16.5566 20.25 20.25 16.5557 20.25 12C20.25 7.44329 16.5567 3.75 12 3.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.13569 9.13471C9.42858 8.84182 9.90346 8.84182 10.1963 9.13471L11.9989 10.9373L13.8001 9.13613C14.093 8.84324 14.5678 8.84324 14.8607 9.13613C15.1536 9.42902 15.1536 9.90389 14.8607 10.1968L13.0596 11.9979L14.8666 13.805C15.1595 14.0979 15.1595 14.5727 14.8666 14.8656C14.5737 15.1585 14.0989 15.1585 13.806 14.8656L11.9989 13.0586L10.1983 14.8593C9.90536 15.1522 9.43049 15.1522 9.13759 14.8593C8.8447 14.5664 8.8447 14.0916 9.13759 13.7987L10.9383 11.998L9.13569 10.1954C8.8428 9.90248 8.8428 9.42761 9.13569 9.13471Z"
        fill="currentColor"
      />
    </svg>
  )
}
